

import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import ReSellerSidebar from "./ReSellerSidebar";
import ReSellerHeader from "./ReSellerHeader";

const ReSellerLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <ReSellerSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
        />
      )}

      {/* MAIN CONTENT */}
      <div className="flex flex-col flex-1 min-w-0 md:ml-64">
        <ReSellerHeader setSidebarOpen={setSidebarOpen} />

        {/* IMPORTANT */}
        <div className="flex-1 p-6 bg-gray-50 overflow-y-auto overflow-x-hidden ">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ReSellerLayout;
